export default __webpack_public_path__ + "static/inrm-direction-a2e51cd64b597e500c38a191f135ec9d.png";